<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12 md8>
                <material-card color="white">
                    <v-form>
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="model.user_id"
                                            label="유저ID"
                                            outline
                                            flatcontentsRegister
                                            disabled
                                            hide-details
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="model.nickname"
                                            label="닉네임"
                                            outline
                                            flat
                                            disabled
                                            hide-details
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="model.email"
                                            label="이메일"
                                            outline
                                            flat
                                            hide-details
                                            disabled
                                            class="purple-input"
                                    ></v-text-field>
                                </v-flex>
                                <hr style="width:100%;">
                                <v-flex xs12>
                                    <v-select
                                            v-model="model.type"
                                            :items="OPTIONS_MEMBER_TYPE.slice(1,OPTIONS_MEMBER_TYPE.length)"
                                            label="등급"
                                            flat
                                            hide-details
                                            disabled
                                            outline
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            label="상태"
                                            value="정상"
                                            outline
                                            flat
                                            hide-details
                                            disabled
                                            color="purple"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="model.sns_type"
                                            label="로그인 타입"
                                            value="FACEBOOK"
                                            outline
                                            flat
                                            hide-details
                                            disabled
                                            color="purple"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="fieldDiv">
                                        <span class="fieldDivLabel">가입일시</span><br>
                                        <span class="fieldDivInput">{{model.created_at |time}}</span>
                                    </div>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="fieldDiv">
                                        <span class="fieldDivLabel">변경일시</span><br>
                                        <span class="fieldDivInput">{{model.updated_at |time}}</span>
                                    </div>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="fieldDiv">
                                        <span class="fieldDivLabel">탈퇴일시</span><br>
                                        <span class="fieldDivInput">{{model.updatedeleted_atd_at |time}}</span>
                                    </div>
                                </v-flex>
                                <v-flex xs12 text-xs-right>
                                    <v-btn class="mr-2 font-weight-light" color="primary" outline @click="cancel">취소</v-btn>
                                    <v-btn class="mx-0 font-weight-light" color="primary" @click="save">저장</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </material-card>
            </v-flex>
            <v-flex xs12 md4>
                <material-card class="v-card-profile">
                    <v-card-text class="text-xs-center">
                        <img width="250px;" :src="model.sns_profile_photo_url">
                    </v-card-text>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

	import * as userApi from '../service/api/user-api'
	import { User } from '../service/model/User'
	import { mapActions, mapGetters } from 'vuex'
	import MyMixinCommon from '../mixins/MyMixinCommon';
	import MyMixinList from '../mixins/MyMixinList'


	export default {
		mixins: [ MyMixinCommon, MyMixinList ],
		data() {
			return {
				dialog: false,
				model: new User(),
				user_id: null
			}
		},
		created() {


            if(this.getUserId()){

            	this.user_id = this.getUserId()
	            this.reqDetail()
            }

		},
		methods: {
			...mapGetters( 'user', [ 'getUserId', 'getLoginType' ] ),


			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////

			save() {

				let data = {
					user_id:this.user_id,
					nickname:this.model.nickname,
					type: this.model.type,

				 }


				console.log( `Log ${this.$options.name} data = ${JSON.stringify( data, null, 2 )}` )
				this.$dialog.confirm( '저장하시겠습니까?' )
				.then( dialog => {
					this.reqModify( data)

				} )
				.catch( function() {
				} )
			},
			cancel() {
				this.$router.back()

			},

			/////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////
			reqDetail() {



				return userApi.findUserMe().then( res => {

					if( res.data ) {
						this.model = res.data
					}
				} ).catch( e => {
					this.$dialog.alert( e.message )
				} )

			},
			reqModify( data ) {


				return userApi.modifyUserMe( data, this.user_id ).then( res => {

					if( res.data ) {

						this.$router.back()
					}
				} ).catch( e => {
					this.$dialog.alert( e.message )
				} )

			},

        }
	}
</script>
<style lang="scss">
    .v-input--is-disabled:not(.v-input--is-readonly) {
        .v-input__slot {
            /*border: 2px solid #ccc !important;*/
            background: #efefef !important;

            input {
                color: #000 !important;
            }

        }
    }

    .fieldDiv {
        width: 100%;
        border: 2px solid rgba(0, 0, 0, .54);
        padding: 0 12px;
        border-radius: 4px;
        height: 54px;
        background: #efefef;


        .fieldDivLabel {
            color: #aaa !important;
            font-size: 12px;
        }

        .fieldDivInput {
            margin-top: 22px;
        }

    }


</style>
